<template>
  <v-dialog
    v-model="dialog"
    width="400px">
    <div class="dialog-container">
      <div class="dialog-header flex-sb">
        <span>Reply Quote</span>
        <span
          class="el-icon-close icon"
          @click="changeDialog"></span>
      </div>
      <div class="dialog-body">
        <p class="question">
          Which type of quote would you like to reply?
        </p>
        <div class="option">
          <v-button @click="handlePriceOnly">Price Only Quote</v-button>
          <p class="tips">Does not require full KYC form. Upgradable later to buyable.</p>
        </div>
        <div class="option">
          <v-button
            type="success"
            @click="handleBuyable">Buyable Quote</v-button>
          <p class="tips">Requires full KYC form data</p>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },

    handlePriceOnly(){
      this.changeDialog()
      this.$emit('priceOnly')
    },

    handleBuyable(){
      this.changeDialog()
      this.$emit('buyable')
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
    .icon{
      cursor: pointer;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .question{
      color: rgba(36, 41, 46, 1);
    }
    .option{
      margin-top: 20px;
      .tips{
        font-size: 12px;
        color: rgba(106, 115, 125, 1);
        margin-top: 5px;
        text-align: center;
      }
      .el-button{
        width: 100%;
      }
    }
  }
}
</style>
